module.exports = __webpack_public_path__ + "static/media/BigDataAnalysis.e0ee626c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Svg/BigDataAnalysis.svg
// module id = 1373
// module chunks = 0